// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape, PlateTargetEligibility} from 'pipelines/StepShapeUtils';

export const PUT_PLATES_IN_INVENTORY_STEP_SHAPES = [
  {
    stepType: PipelineStepType.PUT_PLATES_IN_INVENTORY,
    isDeprecated: false,
    version: 0,
    plateTargetEligibility: PlateTargetEligibility.SCRATCH_ONLY,
    inputDataShapes: {
      'Input plates': {
        systemName: 'Input plates',
        displayName: 'Input plates',
        kind: PipelineStepDataKind.PLATE,
        isMulti: true,
        isRequired: true
      }
    },
    outputDataShapes: {
      Outputs: {
        systemName: 'Outputs',
        displayName: 'Outputs',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      Errors: {
        systemName: 'Errors',
        displayName: 'Errors',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: false
      }
    },
    config: {
      plateHeight: {
        kind: 'integer',
        required: true
      },
      plateWidth: {
        kind: 'integer',
        required: true
      },
      plateSchemaId: {
        kind: 'domain',
        required: true,
        types: [
          'PLATE_SCHEMA'
        ]
      },
      folderId: {
        kind: 'domain',
        required: true,
        types: [
          'FOLDER'
        ]
      },
      parentStorableId: {
        kind: 'domain',
        required: true,
        types: [
          'LOCATION'
        ]
      },
      studyIds: {
        kind: 'array',
        required: false,
        elementSpec: {
          kind: 'domain',
          required: true,
          types: [
            'STUDY'
          ]
        }
      },
      columnMapping: {
        kind: 'columnMapping',
        required: true,
        fields: {
          wellSchemaFields: {
            kind: 'schemaFields',
            required: true,
            rowSourceField: 'plateSchemaId',
            surfaceFieldRequiredness: true
          }
        }
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
